import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'

interface Props {
  open: boolean
  onClose: () => void
  onRemove: () => void
}

const RemovePlayerDialog = ({ open, onClose, onRemove }: Props) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Remove player?</DialogTitle>
      <DialogContent>
        <DialogContentText>Are you sure you want to remove this player from the challenge?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onRemove}>Yes, remove</Button>
      </DialogActions>
    </Dialog>
  )
}

export default RemovePlayerDialog
